import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_DisasterList',
  name: 'CDS_VF_DisasterList',
  component: App,
  meta: {
    pageProperty: {
      title: '災害一覧',
      controller: 'CDS_CTR_DisasterList',
    },
    guardRules: [user],
  },
};
